module.exports = () => [
  { label: 'Performing physician name', value: '0008,1050', group: 8, element: 4176 },
  { label: 'Referring physician name', value: '0008,0090', group: 8, element: 144 },
  { label: 'Operator name', value: '0008,1070', group: 8, element: 4208 },
  { label: 'Name of Physician Reading Study', value: '0008,1060', group: 8, element: 4192 },
];
